// @flow

import React from 'react';
import type { ComponentType } from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../types';

export type LonghandProps = {
  flexGrow?: string | number,
  flexShrink?: string | number,
  flexBasis?: string | number,
  flexDirection?: string,
};

const withFlexLonghand = <Props: LonghandProps>( // eslint-disable-line arrow-parens
  WrappedComponent: ComponentType<$Diff<Props, LonghandProps>>,
): ComponentType<Props> => {
  const FlexLonghand = ({
    flexGrow,
    flexShrink,
    flexBasis,
    flexDirection,
    wrap,
    ...props
  }) => (
    <WrappedComponent {...props} flexWrap={wrap ? 'wrap' : 'initial'} />
  );

  return styled<typeof FlexLonghand, Theme>(FlexLonghand)`
    ${props => props.flexGrow && css`flex-grow: ${props.flexGrow};`}
    ${props => props.flexShrink && css`flex-shrink: ${props.flexShrink};`}
    ${props => props.flexBasis && css`flex-basis: ${props.flexBasis};`}
    ${props => props.flexDirection && css`flex-direction: ${props.flexDirection};`}
  `;
};

export default withFlexLonghand;
